<template>
  <v-dialog v-model="model" persistent max-width="576px">
    <v-card class="insurance-dialog">
      <v-card-title class="insurance-dialog__title insurance-dialog--padding">
        Insurance
      </v-card-title>
      <v-card-text class="insurance-dialog--padding">
        <div class="insurance-dialog__header">From Hotel4box</div>
        <div class="insurance-dialog__text mt-1 mb-3">
          Would you like to buy an additional insurance for {{ currencySymbol }}{{insurance}} which will fully cover
          from
          loss or damage?
        </div>
        <v-divider></v-divider>
        <v-layout my-2>
          <v-flex class="insurance-dialog__full-coverage">Full coverage:</v-flex>
          <div class="insurance-dialog__full-coverage--price"> {{ currencySymbol }}{{amountTotal.toFixed(2)}}</div>
        </v-layout>
        <v-divider></v-divider>
        <v-layout mt-2>
          <v-flex class="insurance-dialog__insure-for">Insurance for:</v-flex>
          <div class="insurance-dialog__insure-for--price"> {{ currencySymbol }}{{insurance.toFixed(2)}}</div>
        </v-layout>
      </v-card-text>
      <v-card-actions class="insurance-dialog__actions">
        <v-spacer></v-spacer>
        <v-btn class="insurance-dialog__btn--cancel"
               flat
               @click="setInsurance(0)">
          No, Thanks
        </v-btn>
        <v-btn class="insurance-dialog__btn--ok"
               flat
               @click="setInsurance(1)">
          Add Insurance
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'InsuranceDialog',
  props: {
    currencySymbol: {
      required: true,
      type: String,
    },
    insurance: {
      required: true,
      type: Number
    },
    amountTotal: {
      required: true,
      type: Number
    },
    value: {
      required: true,
      type: Boolean
    },
  },
  data() {
    return {
      model: null,
    }
  },
  created() {
    if (this.cardItem) {
      this.cardSelectModel = this.cardItem;
    }
  },
  watch: {
    value() {
      this.model = this.value;
    }
  },
  methods: {
    setInsurance(val) {
      this.$emit('set-insurance', val);
    },
  }
}
</script>

<style scoped lang="stylus">

.insurance-dialog
  width: 576px;
  border-radius: 6px;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.08), 0 2px 8px 0 rgba(0, 0, 0, 0.12);

.insurance-dialog--padding
  padding 17px 24px

.insurance-dialog__title
  font-size 16px
  font-weight 500
  border-bottom 1px #D5D9DE solid

.insurance-dialog__header
  font-size 16px
  font-weight 500

.insurance-dialog__text
  opacity 0.54
  font-size 14px

.insurance-dialog__actions
  border-top 1px #D5D9DE solid

.insurance-dialog__full-coverage
  font-size 16px
  font-weight 500

.insurance-dialog__insure-for
  font-size 14px
  font-weight 500

.insurance-dialog__full-coverage--price
  color #1AA260
  font-size 14px
  font-weight 500

.insurance-dialog__insure-for--price
  color #DD4D40
  font-size 14px
  font-weight 500

.insurance-dialog__btn--cancel,
.insurance-dialog__btn--ok
  text-transform none !important
  width 168px
  border 1px solid #D5D9DE
  border-radius 6px

.insurance-dialog__btn--ok
  background-color #008EFF
  color white


</style>